module.exports = __webpack_public_path__ + "static/media/threat-advisory.a320d7a9.svg";